<template>
  <div>
    <breadcrumb-header
      :items="breadcrumbs"
      help-link="/docs/publisher/managing-shifts/my-shifts"
    >
      <template
        #append
      >
        <v-spacer />
        <div
          class="text-right align-top"
        >
          <v-btn
            v-if="!xs && can('submit_availability')"
            size="large"
            color="secondary"
            prepend-icon="fas fa-plus"
            :class="xs ? 'float-left' : 'float-right'"
            :text="t('smpw.submit_availability')"
            to="/mycalendar"
          />
        </div>
      </template>
    </breadcrumb-header>
    <div v-if="user">
      <v-alert
        v-if="['required', 'rejected'].includes(user.profile_image_status)"
        type="error"
        class="mb-4"
      >
        <div
          v-if="user.profile_image_status == 'required'"
          class="text-body-large"
        >
          {{ t('images.missing_profile_message') }}
        </div>
        <div
          v-else
          class="text-body-large"
        >
          {{ t('smpw.image_rejected_message') }}
        </div>
        <router-link
          to="/mydetails"
          class="btn btn-primary"
        >
          {{ t('global.view_profile') }}
        </router-link>
      </v-alert>
      <shift-list
        :user="user"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import { useAuth, useDataTableUtilities, usePermissions } from '@/composables';
import { useErrorStore } from '@/stores/errors';
import { useMenuStore } from '@/stores/menu';
import ShiftList from '../ShiftList.vue';

const { xs } = useDisplay();
const { t } = useI18n();
const { handleError } = useErrorStore();
const { appendIncludes } = useDataTableUtilities();

const breadcrumbs = computed(() => [
  {
    title: t('shift.mine'),
  },
]);

const { can } = usePermissions();
const { authUser } = useAuth();
const user = ref<App.Models.User>();

const menuStore = useMenuStore();
const { unacknowledgedShiftsCount } = storeToRefs(menuStore);

async function loadData() {
  unacknowledgedShiftsCount.value = 0;
  const includes = ['unwantedLocations', 'profile_image_status'];
  const userId = authUser.id;
  const url = `/api/users/${userId}`;
  const realUrl = appendIncludes(url, includes);
  try {
    const response = await axios.get(realUrl);
    user.value = response.data.data;
  }
  catch (error) {
    handleError(error, t('errors.cannot_load'));
  }
}

loadData();
</script>
